import React from "react";
import StickyVideoUp from "../../StickyVideoUp";
import "./Camps.css";
import CategoryCamps from "./CategoryCamps/CategoryCamps";
import CampsHero from "../../Images/CampsHero.webp";

function Camps() {
  return (
    <>
      <StickyVideoUp />
      <div className="CampsHero">
        <img src={CampsHero} alt="" />
      </div>
      <CategoryCamps />
    </>
  );
}

export default Camps;
